<span
  class="op-ian-wp-status"
  [ngClass]="highlightClass"
>
  <span
    class="op-ian-wp-status--text"
    [textContent]="status.name"
  ></span>
</span>
